export const invalidMarketingTitles = ['manager']

export default {
  invalidMarketingTitles,
}
